
import styles from "./ErrorState.module.css";

export default function ErrorState({ onRetry }) {
  return (
    <section className={styles.wrapper}>
      <div className={styles.card}>


        <h2 className={styles.title}>
          Something went wrong
        </h2>

        <p className={styles.message}>
          We're experiencing a temporary issue while loading venue information.
          Please try again in a few moments.
        </p>

        <button
          type="button"
          className={styles.button}
          onClick={onRetry}
        >
          ↻ Retry
        </button>

      </div>
    </section>
  );
}